export default "__VITE_ASSET__Cx5l1A7W__"